import { leaveFormulas } from './leaveFormulas.ts'

/**
 * Remote work is defined by the leave type's formula, not by the `isRemote` stored on the leave type
 * (no screen sets it, it will be removed). Ids of the remote formulas, for database queries:
 * `{ $in: ['$type.formula', REMOTE_LEAVE_FORMULA_IDS] }`.
 */
export const REMOTE_LEAVE_FORMULA_IDS: number[] = leaveFormulas
  .filter(formula => formula.isRemote)
  .map(formula => Number(formula._id))

/**
 * Whether a leave type is remote work, from its formula (id, or populated formula object).
 * A type without formula, or not populated (an id only), is not remote.
 */
export const isRemoteLeaveType = (type?: { formula?: number | string | { _id?: number | string } | null } | string | null): boolean => {
  if (!type || typeof type !== 'object') return false
  const formula = type.formula
  const formulaId = formula && typeof formula === 'object' ? formula._id : formula
  if (formulaId === null || formulaId === undefined || formulaId === '') return false
  return REMOTE_LEAVE_FORMULA_IDS.includes(Number(formulaId))
}
